import { Deserializable } from './deserializable';
import { ControlDevice } from './controlDevice';
import { ControlAction } from './controlAction';
import { PilomatSystemInfo } from './pilomatSystemInfo';
import { Log } from '../util/log';
import { DateHelper } from '../util/dateHelper';


export class ExecutionsLogEvent implements Deserializable {

  serial : string;
  message : string;
  execution : string;
  executionType : string;
  date : string;
  dateDate : Date;
  dateFriendly : string;

  result : string;

  public static ResultIdle: string = "Idle";
  public static ResultExecuting: string = "Executing";
  public static ResultExecuted: string = "Executed";
  public static ResultError: string = "Error";
  public static ErrorCannotStop: string = "cannot stop";

  public static ProgrammedExecution: string = "Programmed";
  public static PeriodicExecution: string = "Periodic";

  deserialize(input: any) {

    Object.assign(this, input);

    this.dateDate = DateHelper.parseDate(input.date);
    this.dateFriendly = DateHelper.formatDateTimeFriendly(this.dateDate);

    if(this.executionType == ExecutionsLogEvent.ProgrammedExecution){
      this.executionType = $localize`:@@ExecutionsLogEventModel_execution_type_programmed:Programmato`;
    } else if(this.executionType == ExecutionsLogEvent.PeriodicExecution){
      this.executionType = $localize`:@@ExecutionsLogEventModel_execution_type_periodic:Periodico`;
    } 

    this.dateDate = new Date(this.date);
    if(this.message == ExecutionsLogEvent.ResultIdle){
      this.result = $localize`:@@ExecutionsLogEventModel_result_idle:In attesa`;
    } else if(this.message == ExecutionsLogEvent.ResultExecuting){
      this.result = $localize`:@@ExecutionsLogEventModel_result_executing:In esecuzione`;
    } else if(this.message == ExecutionsLogEvent.ResultExecuted){
      this.result = $localize`:@@ExecutionsLogEventModel_result_executed:Eseguito`;
    } else if(this.message == ExecutionsLogEvent.ResultError){
      //aggiungere traduzioni errori

      // if(this.errorDescription == ExecutionsLogEvent.ErrorCannotStop){
      //   this.result = $localize`:@@ExecutionsLogEventModel_result_error:Errore` + ": " + $localize`:@@ExecutionsLogEventModel_result_error_cannot_stop:Impossibile terminare`;
      // } else{
        //fallback errore non tradotto, da decidere se va lasciato
        this.result = $localize`:@@ExecutionsLogEventModel_result_error:Errore` + ": " + this.message;
      // }
    }


    return this;
  }

}
